export default __webpack_public_path__ + "static/media/Circus_07.e02196a4.png";